import { useCurrentUser } from '~/shared/hooks/useCurrentUser';
import { ExpertMattersView } from './ExpertMattersView';
import AttorneyMattersView from './AttorneyMattersView';

const MattersPage = () => {
  const { user: currentUser } = useCurrentUser();

  if (!currentUser) {
    return null;
  }

  if (currentUser.role === 'Expert') {
    return <ExpertMattersView currentUser={currentUser} />;
  }

  return <AttorneyMattersView currentUser={currentUser} />;
};

export default MattersPage;
